import React from 'react';
import './WhyUs.css';
import { useLanguage } from '../../../../context/LanguageContext';
import translations from '../../../../translations';

// Import image
import whyUsImage from '../../../../assets/background4.webp';

const WhyUs = () => {
  const { language, direction } = useLanguage();
  const t = translations[language];
  const isRTL = direction === 'rtl';

  const uniqueSellingPoints = [
    {
      id: 1,
      title: language === 'en' ? 'Industry Leaders' : 'رواد الصناعة',
      description: language === 'en'
        ? 'Excellence, experience, and cutting-edge technology delivering large-scale projects with unmatched quality.'
        : 'التميز والخبرة والتكنولوجيا المتقدمة لتنفيذ المشاريع الكبرى بجودة لا مثيل لها.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M8.21 13.89L7 23l5-3 5 3-1.21-9.12"></path>
          <path d="M15 7a3 3 0 1 0-6 0"></path>
          <path d="M12 2a5 5 0 0 1 5 5c0 2.39-1.31 4.5-3.4 5.25L13.5 17h-3l-.11-4.75C8.31 11.5 7 9.39 7 7a5 5 0 0 1 5-5z"></path>
        </svg>
      )
    },
    {
      id: 2,
      title: language === 'en' ? 'Quality & Customer Focus' : 'الجودة وخدمة العملاء',
      description: language === 'en'
        ? 'Quality and customer satisfaction are our foundation and driving force at Advanced Elements Contracting.'
        : 'الجودة ورضا العملاء هما أساسنا وقوتنا الدافعة في العناصر المتطورة للمقاولات.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          <path d="M9 12l2 2 4-4"></path>
        </svg>
      )
    },
    {
      id: 3,
      title: language === 'en' ? '15 Years of Expertise' : '15 عاماً من الخبرة',
      description: language === 'en'
        ? 'Since 2011, we\'ve built resilience by overcoming challenges and turning them into opportunities.'
        : 'منذ 2011، بنينا المرونة من خلال التغلب على التحديات وتحويلها إلى فرص.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <polyline points="12 6 12 12 16 14"></polyline>
        </svg>
      )
    },
    {
      id: 4,
      title: language === 'en' ? 'Innovative Solutions' : 'حلول مبتكرة',
      description: language === 'en'
        ? 'Our R&D team delivers creative and technical solutions that exceed expectations.'
        : 'يقدم فريق البحث والتطوير لدينا حلولاً إبداعية وتقنية تفوق التوقعات.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M9 18h6"></path>
          <path d="M10 22h4"></path>
          <path d="M12 2a7 7 0 0 1 7 7c0 2.38-1.19 4.47-3 5.74V17a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2v-2.26C6.19 13.47 5 11.38 5 9a7 7 0 0 1 7-7z"></path>
        </svg>
      )
    },
    {
      id: 5,
      title: language === 'en' ? 'Investing in People' : 'الاستثمار في الكوادر',
      description: language === 'en'
        ? 'We prioritize top talent and foster skills like positivity and continuous learning.'
        : 'نولي الأولوية للكفاءات المتميزة ونعزز مهارات الإيجابية والتعلم المستمر.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
          <circle cx="9" cy="7" r="4"></circle>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
        </svg>
      )
    }
  ];

  return (
    <section className={`whyus-section ${isRTL ? 'rtl' : ''}`} id="whyus">
      <div className="whyus-container">
        <div className="whyus-header">
          <h2 className="whyus-title">{t.whyUsTitle} <span className="whyus-highlight">AECO</span>{t.whyUsQuestionMark}</h2>
          <div className="whyus-divider"></div>
        </div>

        <div className="whyus-grid">
          {/* Left Side - Image */}
          <div className="whyus-image-side">
            <div className="whyus-image-container">
              <img
                src={whyUsImage}
                alt={language === 'en' ? 'Why Choose Us' : 'لماذا تختارنا'}
              />
            </div>
          </div>

          {/* Right Side - Unique Selling Points */}
          <div className="whyus-content-side">
            <div className="usp-list">
              {uniqueSellingPoints.map((point) => (
                <div key={point.id} className="usp-item">
                  <div className="usp-icon">
                    {point.icon}
                  </div>
                  <div className="usp-content">
                    <h3 className="usp-title">{point.title}</h3>
                    <p className="usp-description">{point.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;